<div class="feedback-container">
  <div id="selectedOptions" [@chatBotFadeInAnimationSequence]>
    <div class="flex justify--start sequence-item">
      <div class="smart-fix-text agent">Did you find this useful?</div>
    </div>
    <div *ngIf="selectedOptions.length === 0" class="mb-4 sequence-item">
      <ng-container *ngFor="let option of feedbackOptions">
        <dgx-components-button
          class="pre-wrap-text fix-width mb-4"
          variant="secondary"
          [fill]="false"
          data-testid="chat-option-button"
          (click)="processOption(option)"
        >
          {{ option.label }}
        </dgx-components-button>
      </ng-container>
    </div>
    <ng-container *ngFor="let option of selectedOptions">
      <div>
        <div [@chatBotFadeInAnimationSequence]>
          <div class="flex justify--end sequence-item">
            <div class="smart-fix-text user">
              {{ option.label }}
            </div>
          </div>
          <div class="flex justify--start sequence-item">
            <div class="smart-fix-text agent">
              {{ option.message }}
            </div>
          </div>
          <div
            *ngIf="option === selectedOptions[selectedOptions.length - 1]"
            class="mb-4 sequence-item"
          >
            <ng-container *ngFor="let option of option.children">
              <dgx-components-button
                *ngIf="option.label !== ''"
                class="pre-wrap-text fix-width mb-4"
                variant="secondary"
                [fill]="false"
                data-testid="chat-option-button"
                (click)="processOption(option)"
              >
                {{ option.label }}
              </dgx-components-button>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
